import React from 'react';
import { DndContext, PointerSensor, useSensor, useSensors, closestCenter } from '@dnd-kit/core';
import { SortableContext, useSortable, arrayMove, rectSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Horizontal/wrap-flow sortable list. Used by room-select and trade-select.
// Migrated from react-beautiful-dnd to @dnd-kit (Phase 6: PFM-2599).

const listStyle = { display: 'flex', flexWrap: 'wrap' };

const SortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </div>
  );
};

export const SimpleSort = (props) => {
  // Activate drag only after a small pointer movement so click handlers on
  // chips still fire when the user just taps.
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 4 } }));

  const onDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = props.items.findIndex((i) => i.id === active.id);
    const newIndex = props.items.findIndex((i) => i.id === over.id);
    if (oldIndex < 0 || newIndex < 0) return;
    const items = arrayMove(props.items, oldIndex, newIndex);
    props.onSort && props.onSort(items);
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={props.items.map((i) => i.id)} strategy={rectSortingStrategy}>
        <div style={listStyle}>
          {props.items.map((item) => (
            <SortableItem key={item.id} id={item.id}>
              {item.content}
            </SortableItem>
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};
